import $ from "jquery";
import wrapper from "flow/promise/promiseWrapper";
import MyFlow from "flow/MyFlow";

export default function when(myFlow: MyFlow, ...params: any[]): JQueryPromise<any> {
    return wrapper.wrap<any>(myFlow, $.when(...params));
}
